'use strict';

var isObject = require('./utils').isObject,
    defaultOptions = {
        resolved: function() {}
    };

function Captcha(options) {
    if (!isObject(options)) {
        options = {};
    }

    this.options = Object.assign({}, defaultOptions, options);
}

Captcha.prototype = {
    solve: function(challenge) {
        var key = Object.keys(challenge)[0],
            url = challenge[key].url,
            results = {};

        results[key] = url;

        this.options.resolved({
            type: 'captcha',
            results: results,
            key: this.options.challengeKey
        });
    }
};

module.exports = Captcha;
